import type { PMSVendorData, PmsSourceKey } from '@/types/pms.types';
import type { CredentialSummaryKind } from '../components/CredentialSummary';

/**
 * Tenants whose saved record still has a non-blank secret came in via the
 * legacy key/secret flow — preserve that path. Everyone else (including new
 * tenants with no record) gets the OAuth subdomain flow.
 */
export const usesOAuthView = (secret: string | undefined | null): boolean => !(secret && String(secret).trim());

/**
 * Which credential rows a vendor's stored record shows (spec §5.3). The one
 * place this is decided: the settings panels and the internal account page's
 * read-only settings view (DV-3500) both ask here. Not on `vendorRegistry`,
 * which imports the panels — a panel importing it back would be a cycle.
 */
export const credentialKindFor = (
  pmsSource: PmsSourceKey,
  record: Pick<PMSVendorData, 'secret'>,
): CredentialSummaryKind => {
  switch (pmsSource) {
    case 'rentvine':
      return 'keySecret';
    case 'appfolio':
      return usesOAuthView(record.secret) ? 'subdomainOnly' : 'keySecretOnly';
    case 'buildium':
      return 'marketplace';
  }
};
